import { createSelector } from "reselect";

const getData = state => state.user.profileVisitors;

const getTopProfileVisitors = createSelector(
  getData,
  profileVisitors => profileVisitors
);
export default getTopProfileVisitors;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getTopProfileVisitors.js